module.exports = __webpack_public_path__ + "img/copper_vip_intro.66b33f6c.png";